import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { updateMcpCredentials, USER_MCP_QUERY_KEYS } from '../../api';

export const useUpdateMcpCredentials = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      mcpCatalogId,
      headers,
    }: {
      mcpCatalogId: string;
      headers?: Record<string, string>;
    }) => updateMcpCredentials(mcpCatalogId, headers),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: USER_MCP_QUERY_KEYS.installed });
      // New creds → the cached /test result is stale; re-check so the health badge + composer
      // reflect the change without a manual refresh.
      await queryClient.invalidateQueries({
        queryKey: USER_MCP_QUERY_KEYS.health(variables.mcpCatalogId),
      });
      notificationService.showSuccess(
        t('userMcpServers.useUpdateMcpCredentials.credentialsUpdated'),
      );
    },
    onError: (error) => {
      notificationService.showError(
        t('userMcpServers.useUpdateMcpCredentials.failedToUpdateCredentials'),
      );
      logger.error('Failed to update MCP credentials:', error);
    },
  });
};
